import { jsx as n, jsxs as d, Fragment as N } from "react/jsx-runtime";
import * as x from "react";
import { Slot as y } from "../../../../../node_modules/@radix-ui/react-slot/dist/index.js";
import { cva as I } from "../../../../../node_modules/class-variance-authority/dist/index.js";
import { cn as u } from "../../utils/cn.js";
import S from "../Spinner/Spinner.js";
const T = x.forwardRef((f, r) => {
  const {
    className: m,
    variant: p = "default",
    size: i = "default",
    asChild: b = !1,
    isLoading: t = !1,
    children: o,
    icon: g,
    disabled: v = !1,
    ...a
  } = f, l = g != null ? /* @__PURE__ */ n(g, { size: 16 }) : null, h = t ? /* @__PURE__ */ n(S, {}) : null;
  let e = null;
  switch (i) {
    case s["ICON-SM"]:
    case s.ICON: {
      e = t ? null : l;
      break;
    }
    case s.SM:
    case s.DEFAULT:
    case s.LG: {
      e = /* @__PURE__ */ d(N, { children: [
        t ? null : l,
        o
      ] });
      break;
    }
  }
  if (!t && e == null)
    return null;
  const c = u(A({ variant: p, size: i, className: m }));
  return b ? /* @__PURE__ */ n(y, { ref: r, className: c, ...a, children: o }) : /* @__PURE__ */ d(
    "button",
    {
      ref: r,
      className: c,
      disabled: t || v,
      ...a,
      children: [
        h,
        e
      ]
    }
  );
});
T.displayName = "Button";
const A = I(
  u(
    "gst-border-0 gst-border-solid",
    // Foundation reset
    "gst-inline-flex gst-items-center gst-justify-center gst-gap-2 gst-whitespace-nowrap gst-rounded-lg gst-text-sm gst-font-semibold gst-transition-colors focus-visible:gst-outline-none gst-ring-offset-2 focus-visible:gst-ring-2 disabled:gst-pointer-events-none disabled:gst-opacity-50 [&_svg]:gst-pointer-events-none [&_svg]:gst-size-4 [&_svg]:gst-shrink-0 focus-visible:gst-ring-ring gst-text-foreground"
  ),
  {
    variants: {
      variant: {
        default: "gst-bg-primary gst-text-primary-foreground hover:gst-bg-primary/90",
        destructive: "gst-bg-destructive focus-visible:gst-ring-destructive gst-text-destructive-foreground gst-shadow-sm hover:gst-bg-destructive/90",
        secondary: "gst-border gst-border-input gst-bg-background gst-shadow-sm hover:gst-bg-accent hover:gst-text-accent-foreground",
        plain: "gst-bg-background hover:gst-text-accent-foreground hover:gst-bg-accent",
        "plain-primary": "gst-text-primary gst-bg-transparent"
      },
      size: {
        default: "gst-h-10 gst-px-4 gst-py-2",
        sm: "gst-h-8 gst-px-3 gst-gap-1.5",
        lg: "gst-h-11 gst-px-8",
        icon: "gst-h-10 gst-w-10",
        "icon-sm": "gst-h-8 gst-w-8"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), s = {
  DEFAULT: "default",
  SM: "sm",
  LG: "lg",
  ICON: "icon",
  "ICON-SM": "icon-sm"
}, R = {
  DEFAULT: "default",
  DESTRUCTIVE: "destructive",
  SECONDARY: "secondary",
  PLAIN: "plain",
  "PLAIN-PRIMARY": "plain-primary"
};
export {
  s as BUTTON_SIZES,
  R as BUTTON_VARIANTS,
  T as Button,
  A as buttonVariants
};
